module.exports = __webpack_public_path__ + "img/growing-icon.ecd703be.svg";